export const GET_STEP_REQUEST = 'GET_STEP_REQUEST';
export const GET_STEP_SUCCESS = 'GET_STEP_SUCCESS';
export const GET_STEP_FAIL    = 'GET_STEP_FAIL';

export const GET_STEPS_BY_CAREER_PATH_REQUEST = 'GET_STEPS_BY_CAREER_PATH_REQUEST';
export const GET_STEPS_BY_CAREER_PATH_SUCCESS = 'GET_STEPS_BY_CAREER_PATH_SUCCESS';
export const GET_STEPS_BY_CAREER_PATH_FAIL    = 'GET_STEPS_BY_CAREER_PATH_FAIL';

export const ADD_STEP_REQUEST = 'ADD_STEP_REQUEST';
export const ADD_STEP_SUCCESS = 'ADD_STEP_SUCCESS';
export const ADD_STEP_FAIL    = 'ADD_STEP_FAIL';

export const UPDATE_STEP_REQUEST = 'UPDATE_STEP_REQUEST';
export const UPDATE_STEP_SUCCESS = 'UPDATE_STEP_SUCCESS';
export const UPDATE_STEP_FAIL    = 'UPDATE_STEP_FAIL';

export const DELETE_STEP_REQUEST = 'DELETE_STEP_REQUEST';
export const DELETE_STEP_SUCCESS = 'DELETE_STEP_SUCCESS';
export const DELETE_STEP_FAIL    = 'DELETE_STEP_FAIL';

export const SET_STEP_LOADING = 'SET_STEP_LOADING';

// ── Action Creators ───────────────────────────────────────
export const getStepRequest = (stepId) => ({
    type: GET_STEP_REQUEST,
    payload: { stepId }
});
export const getStepSuccess = (step) => ({
    type: GET_STEP_SUCCESS,
    payload: step
});
export const getStepFail = (error) => ({
    type: GET_STEP_FAIL,
    error
});

export const getStepsByCareerPathRequest = (careerPathId) => ({
    type: GET_STEPS_BY_CAREER_PATH_REQUEST,
    payload: { careerPathId }
});
export const getStepsByCareerPathSuccess = (steps) => ({
    type: GET_STEPS_BY_CAREER_PATH_SUCCESS,
    payload: steps
});
export const getStepsByCareerPathFail = (error) => ({
    type: GET_STEPS_BY_CAREER_PATH_FAIL,
    error
});

export const addStepRequest = (careerPathId, stepData) => ({
    type: ADD_STEP_REQUEST,
    payload: { careerPathId, stepData }
});
export const addStepSuccess = (step) => ({
    type: ADD_STEP_SUCCESS,
    payload: step
});
export const addStepFail = (error) => ({
    type: ADD_STEP_FAIL,
    error
});

export const updateStepRequest = (careerPathId, stepId, stepData) => ({
    type: UPDATE_STEP_REQUEST,
    payload: { careerPathId, stepId, stepData }
});
export const updateStepSuccess = (step) => ({
    type: UPDATE_STEP_SUCCESS,
    payload: step
});
export const updateStepFail = (error) => ({
    type: UPDATE_STEP_FAIL,
    error
});

export const deleteStepRequest = (careerPathId, stepId) => ({
    type: DELETE_STEP_REQUEST,
    payload: { careerPathId, stepId }
});
export const deleteStepSuccess = (stepId) => ({
    type: DELETE_STEP_SUCCESS,
    payload: { stepId }
});
export const deleteStepFail = (error) => ({
    type: DELETE_STEP_FAIL,
    error
});

export const setStepLoading = (loading) => ({
    type: SET_STEP_LOADING,
    payload: loading
});